import api from '@/api/settings';
import store from '@/store';
import { fromLongToShort } from '@/components/shared/languageCodes';

const getSettings = context => new Promise(((resolve, reject) => {
  api.getSettings()
    .then((response) => {
      context.commit('SET_USER_SETTINGS', response);
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const setSettings = (context, config) => new Promise(((resolve, reject) => {
  api.setSettings(config)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const setBackRoute = (context, backRoute) => new Promise(((resolve, reject) => {
  context.commit('SET_BACK_ROUTE', backRoute);
}));

const setLastClassesPath = (context, route) => new Promise(((resolve, reject) => {
  context.commit('SET_LAST_CLASSES_PATH', route);
}));

const setAppleLoginDetails = (context, details) => new Promise(((resolve, reject) => {
  context.commit('SET_APPLE_LOGIN_DETAILS', details);
}));

const setLearnedLanguage = (context, lang) => new Promise(((resolve, reject) => {
  context.commit('SET_LEARNED_LANGUAGE', lang);
}));

const setSiteLanguage = (context, lang) => new Promise(((resolve, reject) => {
  context.commit('SET_SITE_LANGUAGE', lang);
  context.commit('SET_NARRATOR_LANGUAGE', fromLongToShort[lang]); // Voiceover and windows narrator lang support
}));

const setWindowWidth = (context, size) => new Promise(((resolve, reject) => {
  context.commit('SET_WINDOW_WIDTH', size);
}));

const setUserIsLoggedIn = (context, userIsLoggedIn) => new Promise(((resolve, reject) => {
  context.commit('SET_USER_IS_LOGGED_IN', userIsLoggedIn);
}));

const setSessionExpired = (context, sessionExpired) => new Promise(((resolve, reject) => {
  context.commit('SET_SESSION_EXPIRED', sessionExpired);
}));

// const setForceWebViewStatus = (context, forceWebViewStatus) => new Promise((resolve, reject) => {
//   context.commit('SET_FORCE_WEB_VIEW_STATUS', forceWebViewStatus);
// });

const setDktDeeplinkParams = (context, object) => new Promise((resolve, reject) => {
  context.commit('SET_DKT_DEEPLINK_PARAMS', object);
});

const setHandledUnauthorizedError = (context, handledUnauthorizedError) => new Promise(((resolve, reject) => {
  context.commit('SET_HANDLED_UNAUTHORIZED_ERROR', handledUnauthorizedError);
}));

const setGuestLink = (context, guestLink) => new Promise(((resolve, reject) => {
  context.commit('SET_GUEST_LINK', guestLink);
}));

const setGuestError = (context, guestError) => new Promise(((resolve, reject) => {
  context.commit('SET_GUEST_ERROR', guestError);
}));

const setAppBannerVisible = (context, appBannerVisible) => new Promise(((resolve, reject) => {
  context.commit('SET_APP_BANNER_VISIBLE', appBannerVisible);
}));

const setNarratorLanguage = (context, lang) => new Promise(((resolve, reject) => {
  context.commit('SET_NARRATOR_LANGUAGE', lang);
}));

const setWCAGSetting = (context, object) => {
  context.commit('SET_WCAG_SETTING', object);
};

export default {
  getSettings,
  setSettings,
  setBackRoute,
  setLastClassesPath,
  setAppleLoginDetails,
  setLearnedLanguage,
  setSiteLanguage,
  setWindowWidth,
  setUserIsLoggedIn,
  setSessionExpired,
  // setForceWebViewStatus,
  setDktDeeplinkParams,
  setHandledUnauthorizedError,
  setGuestLink,
  setGuestError,
  setAppBannerVisible,
  setNarratorLanguage,
  setWCAGSetting
};



// WEBPACK FOOTER //
// ./src/store/modules/settings/actions.js